import { Box, IconButton, styled } from '@mui/material';
import SortIcon from 'assets/img/icons/caret-down.svg?react';

export const ExpandButton = ({
  expanded,
  onClick,
  display,
}: {
  expanded: boolean;
  onClick: () => void;
  display: boolean;
}) => {
  if (!display) {
    return null;
  }

  return (
    <ExpandButtonWrapper>
      <IconButton size="small" onClick={onClick}>
        <SortIcon
          width={12}
          height={12}
          style={{ transform: expanded ? 'rotate(180deg)' : 'none' }}
        />
      </IconButton>
    </ExpandButtonWrapper>
  );
};

const ExpandButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: 0,
  borderRadius: '0 0 12px 12px',
  transform: 'translateX(-50%)',
  display: 'flex',
  justifyContent: 'center',
  pointerEvents: 'auto',
  background: 'white',
  width: '100%',
  borderTop: `1px solid ${theme.palette.divider}`,
}));
